import { invisiblyApi } from 'src/redux/api/invisibly-api';
import { APITagType } from 'src/redux/api/invisibly-api.types';
import type {
  ListSchedulingRequestsParams,
  OAuthStartResponse,
  SchedulingConnection,
  SchedulingConnectionsResponse,
  SchedulingRequestsResponse,
  UpdateConnectionCalendarsParams,
} from '../types/scheduling.types';

const schedulingEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    startGoogleCalendarOAuth: builder.mutation<OAuthStartResponse, void>({
      query: () => ({
        method: 'POST',
        url: 'b2b/scheduling/connections/oauth/start',
        data: {},
        handleErrorGlobally: false,
      }),
    }),
    getSchedulingConnections: builder.query<SchedulingConnectionsResponse, void>({
      query: () => ({
        method: 'GET',
        url: 'b2b/scheduling/connections',
        handleErrorGlobally: false,
      }),
      providesTags: [{ id: 'LIST', type: APITagType.PortalSchedulingConnections }],
    }),
    updateSchedulingConnectionCalendars: builder.mutation<SchedulingConnection, UpdateConnectionCalendarsParams>({
      query: ({ connectionId, calendarIds }) => ({
        method: 'PATCH',
        url: `b2b/scheduling/connections/${connectionId}/calendars`,
        data: { calendar_ids: calendarIds },
        handleErrorGlobally: false,
      }),
      invalidatesTags: [{ id: 'LIST', type: APITagType.PortalSchedulingConnections }],
    }),
    revokeSchedulingConnection: builder.mutation<SchedulingConnection, string>({
      query: (connectionId) => ({
        method: 'POST',
        url: `b2b/scheduling/connections/${connectionId}/revoke`,
        data: {},
        handleErrorGlobally: false,
      }),
      invalidatesTags: [{ id: 'LIST', type: APITagType.PortalSchedulingConnections }],
    }),
    getSchedulingBookings: builder.query<SchedulingRequestsResponse, ListSchedulingRequestsParams>({
      query: (params) => ({
        method: 'GET',
        url: 'b2b/scheduling/bookings',
        params,
        handleErrorGlobally: false,
      }),
      providesTags: (_result, _error, params) => [
        { id: `${params.start_date}:${params.end_date}`, type: APITagType.PortalSchedulingRequests },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useStartGoogleCalendarOAuthMutation,
  useGetSchedulingConnectionsQuery,
  useUpdateSchedulingConnectionCalendarsMutation,
  useRevokeSchedulingConnectionMutation,
  useGetSchedulingBookingsQuery,
} = schedulingEndpoints;

export { isGoogleCalendarNotConfiguredError } from '../types/scheduling.types';
